import { put, call, takeLatest } from 'redux-saga/effects'

import {
  getTransactionData,
  getArchiveTransactionData,
  updateArchiveTransactionData,
} from 'Service/Api'

import * as ReconciliationTypes from 'Redux/Types/ReconciliationTypes'
import * as ReconciliationActions from 'Redux/Actions/ReconciliationActions'

function* getReconciliationWorker({ payload }) {
  try {
    const response = yield call(getTransactionData, payload)
    yield put(ReconciliationActions.getTransactionDataSucceeded(response))
  } catch (errors) {
    yield put(ReconciliationActions.getTransactionDataFailed(errors))
  }
}

function* getArchiveTransactionWorker({ payload }) {
  try {
    const updatedPayload = {
      ...payload,
      filters: {
        ...payload?.filters,
        statuses: ['archive'],
      },
    }
    const response = yield call(getArchiveTransactionData, updatedPayload)
    yield put(ReconciliationActions.getArchiveTransactionDataSucceeded(response))
  } catch (errors) {
    yield put(ReconciliationActions.getArchiveTransactionDataFailed(errors))
  }
}

const getTransactionPayload = (payload) => {
  if (payload?.title === 'Transaction Matching') {
    return { limit: 20, offset: 0, filters: {} }
  }
  return { limit: 20, offset: 0, filters: { statuses: ['archive'] } }
}

function* updateArchiveTransactionWorker({ payload }) {
  try {
    const response = yield call(updateArchiveTransactionData, payload?.archivePayload)
    yield put(ReconciliationActions.updateArchiveTransactionDataSucceeded(response))
    const transactionsResponse = yield call(getTransactionData, getTransactionPayload(payload))
    if (payload?.title === 'Transaction Matching') {
      yield put(ReconciliationActions.getTransactionDataSucceeded(transactionsResponse))
    } else {
      yield put(ReconciliationActions.getArchiveTransactionDataSucceeded(transactionsResponse))
    }
  } catch (errors) {
    yield put(ReconciliationActions.updateArchiveTransactionDataFailed(errors))
  }
}

export default function* reconciliationSaga() {
  yield takeLatest(ReconciliationTypes.GET_TRANSACTION_DATA, getReconciliationWorker)
  yield takeLatest(ReconciliationTypes.GET_ARCHIVE_TRANSACTION_DATA, getArchiveTransactionWorker)
  yield takeLatest(
    ReconciliationTypes.UPDATE_ARCHIVE_TRANSACTION_DATA,
    updateArchiveTransactionWorker,
  )
}
